<template>
  <div class="login">
    <div class="container-fluid">
      <div class="form">
        <div class="form">
          <div class="d-flex flex-column">
            <!-- Top Logo :D -->

            <div class="logo text-center">
              <router-link to="/">
                <img
                  width="150"
                  v-if="current_theme == 'dark'"
                  src="@/assets/media/images/logo/logo.png"
                />
                <img
                  width="150"
                  v-else
                  src="@/assets/media/images/logo/logo.png"
                />
              </router-link>
            </div>
            <div class="text-info mb-5">
              <h3 class="text-start">{{ $t("welcomeBack") }}</h3>
              <p class="text-start">{{ $t("signInToAccessDashboard") }}</p>
            </div>
            <ValidationObserver ref="formLogin" @submit.prevent="submit">
              <div class="row">
                <!-- Start title -->
                <ValidationProvider
                  v-slot="{ errors }"
                  class="mb-5"
                  :name="$t('labels.email')"
                  rules="required|email"
                >
                  <base-input
                    :name="$t('labels.email')"
                    type="email"
                    @keypress="isEmailValid($event)"
                    :placeholder="$t('labels.email')"
                    v-model="data.email"
                  />
                  <span v-if="errors[0]" class="error--text d-inline-block">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>

                <ValidationProvider
                  class="mb-5"
                  v-slot="{ errors }"
                  :name="$t('labels.password')"
                  rules="required|min:6|max:250"
                >
                  <base-input
                    :name="$t('labels.password')"
                    type="password"
                    :placeholder="$t('labels.password')"
                    v-model="data.password"
                  />
                  <span v-if="errors[0]" class="error--text d-inline-block">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="button_wrapper center big">
                <v-btn
                  @click="submit"
                  :disabled="loading"
                  :loading="loading"
                  class="center big"
                >
                  تسجيل دخول
                </v-btn>
              </div>
            </ValidationObserver>
          </div>
        </div>

        <div class="img-holder">
          <img src="@/assets/media/images/Pages/login/back.jpg" alt="login" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      // Loading
      loading: false,

      data: {
        email: null,
        password: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      current_theme: "theme_module/current_theme",
    }),
  },

  methods: {
    submit() {
      this.$refs.formLogin.validate().then((d) => {
        if (d) {
          this.loading = true;

          this.axios({
            method: "POST",
            url: "login",
            data: this.data,
          })
            .then((res) => {
              this.loading = false;
              this.$iziToast.success({
                displayMode: 2,
                title: this.$t("validation.success"),
              });

              let user = {
                userId: res.data.data.id,
                token: res.data.data.token,
                userType: res.data.data.user_type,
                username: res.data.data.first_name,
                userImage: res.data.data.avatar,
                userPhone: res.data.data.phone,
              };
              this.$store.dispatch("auth_module/logIn", user);
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              this.$iziToast.error({
                displayMode: 2,
                title: this.$t("validation.error"),
                message:
                  err.response?.data.message ?? err.response?.data.messages,
              });
            });
        } else {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.login {
  min-height: 100vh;
  background: #f5f8fb;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;

  .container-fluid {
    width: 100%;
    max-width: 520px;
  }

  .form {
    width: 100%;
    min-height: auto;
    flex-wrap: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border-radius: 0;
    filter: none;
    overflow: visible;

    .form {
      width: 100%;
      max-width: 420px;
      margin: 0;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 32px;
      padding: 48px 40px 56px;
      box-shadow: 0 30px 60px rgba(20, 34, 67, 0.08);

      > div {
        width: 100%;
      }

      @media (max-width: 480px) {
        padding: 36px 24px 44px;
        border-radius: 24px;
      }
    }

    .img-holder {
      display: none;
    }
  }

  .logo {
    margin-bottom: 24px;

    img {
      max-width: 160px;
    }
  }

  .text-info {
    text-align: center;
    margin-bottom: 32px;

    h3 {
      font-size: 22px;
      font-weight: 700;
      color: #1f2a3d;
      margin-bottom: 8px;
    }

    p {
      font-size: 15px;
      color: #7c889b;
      margin-bottom: 0;
    }
  }

  .row {
    margin: 0;
  }

  .v-input__slot {
    margin-bottom: 12px;
    border: 1px solid #dfe6f1;
    border-radius: 14px;
    background: #fbfdff;
    min-height: 56px;
    padding: 0 18px;
    box-shadow: inset 0 1px 2px rgba(26, 39, 63, 0.05);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &::before,
    &::after {
      display: none;
    }
  }

  .v-input--is-focused .v-input__slot {
    border-color: #0fa68a;
    box-shadow: 0 0 0 3px rgba(15, 166, 138, 0.18);
  }

  .v-input input,
  .v-label {
    color: #1f2a3d;
    font-size: 15px;
  }

  .button_wrapper.center.big {
    width: 100%;
    margin-top: 8px;

    .v-btn {
      width: 100%;
      border-radius: 14px;
      height: 54px;
      background: #0fa68a;
      color: #fff;
      font-weight: 600;
      font-size: 16px;
      letter-spacing: 0;
      text-transform: none;
      box-shadow: 0 15px 35px rgba(15, 166, 138, 0.25);

      &:hover {
        background: #0d9077;
      }
    }
  }

  .error--text {
    margin-top: 6px;
    font-size: 13px;
  }
}
</style>

